import { render, staticRenderFns } from "./ClientManage.vue?vue&type=template&id=1646b702&"
import script from "./ClientManage.vue?vue&type=script&lang=js&"
export * from "./ClientManage.vue?vue&type=script&lang=js&"
import style0 from "./ClientManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports